/**
 * Validaciones compartidas — source_analysis (Historia / Lenguaje).
 */

export const SOURCE_QUOTE_PARAPHRASE_PATTERN =
  /escribi[oó]\s+que|dijo\s+que|afirm[oó]\s+que|sostuvo\s+que|seg[uú]n\s+el\s+autor|el\s+propio\s+.+\s+escribi[oó]|el\s+autor\s+(dijo|afirm[oó]|sostuvo)/i;

export const SOURCE_QUOTE_PLACEHOLDER_PATTERN =
  /^(fragmento para analizar|fragmento representativo|fuente primaria sobre|definici[oó]n relacionada|ejemplo analítico sobre|texto para analizar)/i;

export const SOURCE_REFERENCE_PLACEHOLDER_PATTERN = /^fuente primaria sobre/i;

export function isInvalidSourceQuote(quote: string): boolean {
  const q = String(quote || '').trim();
  if (q.length < 24) return true;
  if (SOURCE_QUOTE_PLACEHOLDER_PATTERN.test(q)) return true;
  if (SOURCE_QUOTE_PARAPHRASE_PATTERN.test(q)) return true;
  return false;
}

export function isInvalidSourceReference(reference: string): boolean {
  const r = String(reference || '').trim();
  if (r.length < 4) return true;
  if (SOURCE_REFERENCE_PLACEHOLDER_PATTERN.test(r)) return true;
  return false;
}
